
import axios from "axios";
import Swal from "sweetalert2";

export const getBannerAPI = async (page = 1) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/banners`, {
      params: {
        page
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getBannerById = async (id ,lang) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.get(`/v1/admin/banners/${id}`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
       "Accept-language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postBanner = async (postData ) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/banners`,postData, {

      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateBanner = async (id, postData) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`/v1/admin/banners/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteBanner = async (id) => {
  const brear = localStorage.getItem("token");
  const lang = localStorage.getItem("i18nextLng");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`/v1/admin/banners/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
